import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {FileUploader} from "ng2-file-upload";
import { SoaImageService } from './../../services/soa-image.service';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import { ContactService } from './../../services/contact.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FactoringInvoiceService } from './../../services/factoring-invoice.service';
import { EncrDecrService } from './../../services/encr-decr.service';


@Component({
  selector: 'app-factoring-invoice',
  templateUrl: './factoring-invoice.component.html',
  styleUrls: ['./factoring-invoice.component.css']
})
export class FactoringInvoiceComponent implements OnInit {
  
  maxDate: Date;

  foldermode:any='';
  custname:any='';
  user_id: any='';
  folder_id:any='';
  company_id: any='';
  APIKEY:any= '';
  customerList:object=[];
  model:any={customer_name:'',invoice:'',date_invoice:'',terms:'',amount:'',reference_number:'',po_number:'',work_week:'',load_number:'',mode:'add'};;
  validFolder:boolean=false;
  existingCustomer:boolean=false;
  manuallyCustomer:boolean=false;
  folderid:any='';
  btnDisable: boolean = false;
  uploaddocform: FormGroup;
  folderImageList:object=[];
  folderDocList:object=[];
  imageDiv:boolean=true;
  delete_id:number=0;
  filePath:any='assets/images/loader.gif';
  pdfSrc: string = '';

  fileModel:any={};

  isRefPoChange: any = 'no';
  
  factoringButton:any=false;
  loaderMode:boolean=false;
  rfolderid:any=0;

  modalRef: BsModalRef;
  config :any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-lg'
  };

  config1 :any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-xl'
  };
  config2 :any = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
  };
 
   /// multiple file upload  code start
   uploadForm: FormGroup;
   public uploader:FileUploader = new FileUploader({
     isHTML5: true
   });
   ////end
  //// set array for terms
  arrayOne(n: number): any[] {
    return Array(n);
  }

  factInvoiceMode:any='add';
  fact_invoice_id:any=0;
 

    constructor(private _router : Router, 
      private _contact:ContactService, 
      private _soaImage:SoaImageService,
      private modalService: BsModalService,
      private toastr: ToastrService,
      private _activatedroute: ActivatedRoute,
      private fb: FormBuilder, 
      private http: HttpClient,
      private EncrDecr: EncrDecrService,
      private _factInvoice:FactoringInvoiceService,
      private datePipe:DatePipe,
    
      ) { }

  ngOnInit() {
    this.user_id =localStorage.getItem('id');
    this.company_id =localStorage.getItem('company_id');
    this.APIKEY =localStorage.getItem('APIKEY');
 
    //get customer for mobile and other role user
    const customerModal={
      APIKEY : this.APIKEY,
      user_id : this.user_id,
      company_id : this.company_id,
      status: 'active',
    }
    this._contact.getContactList(customerModal)
    .subscribe(
      res => { 
           this.customerList=res;
      }, 
    );
    ////end

    this._activatedroute.params.subscribe(params => {
      this.folderid = this.EncrDecr.get(localStorage.getItem('key'), params['id']);
    });



    // this._activatedroute.params.subscribe(params => {
    //   this.folderid=  params['id']; 
    // });
    this.updateCheckInvoice(this.folderid);
   // this.getFolderInfo(this.folderid);

      this.uploadForm = this.fb.group({
      document: [null, null],  
      folder_id:[],
      mobile_number:[],
    
    });
    this.uploadForm.get('folder_id').setValue(this.folderid);

   
    var txt = document.getElementById('fact_amount');
    txt.addEventListener('keyup', myFunc);

    function myFunc(e) {
        var val = this.value;
        var re = /^([0-9]+[\.]?[0-9]?[0-9]?|[0-9]+)$/g;
        var re1 = /^([0-9]+[\.]?[0-9]?[0-9]?|[0-9]+)/g;
        if (re.test(val)) {
            //do something here

        } else {
            val = re1.exec(val);
            if (val) {
                this.value = val[0];
            } else {
                this.value = "";
            }
        }
    }

    this.maxDate = new Date();
  } 

  onSubmitFolder()
  {
    this.btnDisable = true;
    this.model['APIKEY']=this.APIKEY;
    this.model['user_id']=this.user_id;
    this.model['company_id']=this.company_id;
    this.model['folder_id']=this.folderid;
    this.model['invoice_mode']=this.factInvoiceMode
    this.model['invoice_id']=this.fact_invoice_id
    this.model['date_invoice']= this.datePipe.transform(this.model['date_invoice'], 'MM/dd/yyyy, hh:mm a');
    this.model['work_week']= this.datePipe.transform(this.model['work_week'], 'MM/dd/yyyy, hh:mm a');

    //this added by deepak on 25/08/2022, for send invoice email again
    this.model['isRefPoChange'] = this.isRefPoChange;

    this._factInvoice.factInvoiceSave(this.model).subscribe(
      res => { 
          this.toastr.success(res.message, 'Success'); 
          this._router.navigateByUrl('/redirect').then(() => {
          //this._router.navigateByUrl('/mobile/mobile-list');
          this._router.navigateByUrl('/factoring/factoring-tab1');
         });
        },
    ); 
  }

omit_special_char(event)
{   
   var k;  
   k = event.charCode;  //         k = event.keyCode;  (Both can be used)
   //alert(k);
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 45 || (k >= 48 && k <= 57)); 
}
omits_special_char(event)
{   
   var k;  
   k = event.charCode;  //         k = event.keyCode;  (Both can be used)
   return( k == 8 || k == 32 || (k >= 48 && k <= 57)); 
}


isNumberKey(evt)
{
  var charCode = (evt.which) ? evt.which : evt.keyCode;
  if (charCode != 46 && charCode > 31 
    && (charCode < 48 || charCode > 57))
      return false;

  return true;
}
  

onChangeCustomerEvent(ev) {
  const status=  ev.target.value;
  var res = status.split("-");
  var cust_id=  res[1];
  const custModel={
    APIKEY : this.APIKEY,
    user_id : this.user_id,
    //company_id : this.company_id,
    company_id : cust_id,
 }

  this._contact.getContactByid(custModel).subscribe(
    res => { 
      this.model['terms']  =res.data.terms;
    },
  );
}

//////get folder details  
getFolderInfo(folderid){      
  this.loaderMode=true;
  const folderModel={
     APIKEY : this.APIKEY,
     user_id : this.user_id,
     company_id : this.company_id,
     mobile_id : folderid,
  }

  this.rfolderid = this.EncrDecr.set(localStorage.getItem('key'), folderid)


   this._factInvoice.getFolderInfo(folderModel)
  .subscribe(
    res => {   
         this.model=res.data;
         this.pdfSrc=res.data.merge_pdf_path;   
         var  dateInvoice=new Date();

         if(res.data.date_invoice==null){
          this.model['date_invoice']= '' ; //this.datePipe.transform(dateInvoice, 'MM/dd/yyyy');
         }
         else{
          this.model['date_invoice']= this.datePipe.transform(res.data.date_invoice, 'MM/dd/yyyy');
         }
         this.model['invoice_number']= res.data.mobile_invoice_number;
         
        this.model['work_week']= this.datePipe.transform(res.data.work_week, 'MM/dd/yyyy');
         if(this.factInvoiceMode!='add'){
            this.model['terms']=res.data.factterms;
         }

         this.loaderMode=false;
    },
  );
}
////end 

updateCheckInvoice(folderid){
  const folderModel={
     APIKEY : this.APIKEY,
     user_id : this.user_id,
     company_id : this.company_id,
     mobile_id : folderid,
  }
   

  this._factInvoice.updateCheckfact(folderModel)
  .subscribe(
    res => { 
         if(res.status==true){ 
          this.factInvoiceMode='edit';
          this.fact_invoice_id=res.data[0].id;
         }  
         this.getFolderInfo(this.folderid);      
    },
  );
}


check_refpo_change(event)
{   
  this.isRefPoChange = 'yes' ;
}

}
